import { apiClient } from '../lib/api';
import { ENDPOINTS } from './endpoints';

export interface ExtendTrialResponse {
  id: string;
  trialEndsAt: string;
  trialExtendedAt: string;
  trialExtendedByUserId: string;
  trialExtendedReason: string;
}

export async function extendTrial(
  orgId: string,
  params: { days: number; reason: string },
): Promise<ExtendTrialResponse> {
  const res = await apiClient.patch<ExtendTrialResponse>(
    ENDPOINTS.adminOrgs.extendTrial(orgId),
    params,
  );
  return res.data;
}
